const STORAGE_KEYS = {
  VERSION: 'version',
} as const;

/**
 * Stores a key-value pair in the browser's local storage.
 * This function handles potential errors during the storage operation by logging them to the console.
 *
 * @param {string} key - The key under which the value will be stored.
 * @param {string} value - The string value to be stored.
 * @returns {void}
 */
const setItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error storing data:', error);
  }
};

/**
 * Retrieves a value from the browser's local storage by its key.
 * This function handles potential errors during retrieval by logging them and returning `null`.
 *
 * @param {string} key - The key of the item to retrieve.
 * @returns {string | null} The string value associated with the key, or `null` if the key is not found or an error occurred during retrieval.
 */
const getItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error retrieving data:', error);
    return null;
  }
};

export { STORAGE_KEYS, setItem, getItem };
